import React, { useState } from 'react';
import {
  Table, Card, Button, Space, Typography, Form, Input, Select,
  Tag, Drawer, Descriptions, Divider, Modal,
  message, Tooltip, Tabs, Alert, Empty
} from 'antd';
import {
  SearchOutlined,
  ReloadOutlined,
  CheckCircleOutlined,
  FileTextOutlined,
  CopyOutlined,
  DownloadOutlined,
  InfoCircleOutlined
} from '@ant-design/icons';
import { PAYMENT_CHANNEL_LABEL, getConfiguredFeeList, formatFeeText } from '../../../utils/paymentChannels';

const { Text, Title } = Typography;

// ── Mock Data ──
const mockBilled = [
  {
    id: 1, serialNumber: 'BILL202603-001',
    companyName: '东莞康林物联网有限公司', companyId: 'JGSf0Nd7',
    appInfoList: [
      { appName: 'SmartHome Pro', systemPlatform: [{ platformType: 1, region: 1 }] },
      { appName: 'SmartHome Pro', systemPlatform: [{ platformType: 2, region: 1 }] },
      { appName: 'ParkingCloud', systemPlatform: [{ platformType: 1, region: 1 }] },
    ],
    paymentMethod: 1, status: 3, date: '2026-02',
    orderCount: 156,
    orderAmountCny: 2340000, orderAmountUsd: 182000,
    commissionAmountCny: 187200, commissionAmountUsd: 14560,
    commissionRate: 8.00,
    settleAmountCny: 187200, settleAmountUsd: 14560,
    billTime: '2026-03-05 00:00:00', ackBillTime: '2026-03-06 10:30:00',
    isDeductBasePrice: 1, isDeductPaymentFee: 1,
    paymentFeeCny: 28080, paymentFeeUsd: 2730,
    paymentFees: { wechat: { rate: 0.60, fixedFeeCny: 0.30 }, alipay: { rate: 1.50, fixedFeeCny: 0.90 } },
  },
  {
    id: 2, serialNumber: 'BILL202603-002',
    companyName: '东莞康林物联网有限公司', companyId: 'JGSf0Nd7',
    appInfoList: [
      { appName: 'HomeStar', systemPlatform: [{ platformType: 1, region: 1 }] },
      { appName: 'HomeStar', systemPlatform: [{ platformType: 2, region: 1 }] },
      { appName: 'HomeStar', systemPlatform: [{ platformType: 1, region: 2 }] },
    ],
    paymentMethod: 2, status: 2, date: '2026-02',
    orderCount: 89,
    orderAmountCny: 1582000, orderAmountUsd: 245000,
    commissionAmountCny: 188416, commissionAmountUsd: 28067,
    commissionRate: 12.00,
    settleAmountCny: 1067692, settleAmountUsd: 158378,
    billTime: '2026-03-10 00:00:00',
    isDeductBasePrice: 1, isDeductPaymentFee: 1,
    paymentFeeCny: 126560, paymentFeeUsd: 24500,
    paymentFees: { wechat: { rate: 0.60, fixedFeeCny: 0.30 }, alipay: { rate: 1.50, fixedFeeCny: 0.90, fixedFeeUsd: 0.15 }, paypal: { rate: 3.50, fixedFeeUsd: 0.50 } },
  },
  {
    id: 3, serialNumber: 'BILL202603-004',
    companyName: '南京鹤梦信息技术有限公司', companyId: 'HM-8827-X',
    appInfoList: [
      { appName: 'HM IoT App', systemPlatform: [{ platformType: 1, region: 1 }] },
      { appName: 'HM IoT App', systemPlatform: [{ platformType: 2, region: 1 }] },
    ],
    paymentMethod: 2, status: 3, date: '2026-02',
    orderCount: 45,
    orderAmountCny: 675000, orderAmountUsd: 98000,
    commissionAmountCny: 81000, commissionAmountUsd: 11760,
    commissionRate: 12.00,
    settleAmountCny: 535950, settleAmountUsd: 74578,
    billTime: '2026-03-15 00:00:00', ackBillTime: '2026-03-08 14:00:00',
    isDeductBasePrice: 1, isDeductPaymentFee: 1,
    paymentFeeCny: 33750, paymentFeeUsd: 4410,
    paymentFees: { wechat: { rate: 0.60, fixedFeeCny: 0.30 }, applepay: { rate: 2.00 } },
  },
  {
    id: 4, serialNumber: 'BILL202603-005',
    companyName: '捷顺科技股份有限公司', companyId: 'A619355x',
    appInfoList: [
      { appName: 'ParkingCloud', systemPlatform: [{ platformType: 1, region: 1 }] },
      { appName: 'ParkingCloud', systemPlatform: [{ platformType: 2, region: 1 }] },
      { appName: 'SmartHome Pro', systemPlatform: [{ platformType: 1, region: 1 }] },
    ],
    paymentMethod: 1, status: 2, date: '2026-02',
    orderCount: 78,
    orderAmountCny: 1170000, orderAmountUsd: 0,
    commissionAmountCny: 74880, commissionAmountUsd: 0,
    commissionRate: 8.00,
    settleAmountCny: 74880, settleAmountUsd: 0,
    billTime: '2026-03-05 00:00:00',
    isDeductBasePrice: 1, isDeductPaymentFee: 0,
  },
];

const mockUnbilled = [
  {
    id: 5,
    companyName: '捷顺科技股份有限公司', companyId: 'A619355x',
    appInfoList: [
      { appName: 'ParkingCloud' },
      { appName: 'SmartHome Pro' },
    ],
    paymentMethod: 1, status: 1,
    orderCount: 312,
    orderAmountCny: 4680000, orderAmountUsd: 0,
  },
];

// 账单明细 mock
const mockDetailOrders = [
  { orderId: 'ORD20260215001', outTradeNo: 'WX20260215001', status: 1, packageName: '云存储月卡', packageId: 'PKG_001', appInfo: 'SmartHome Pro (iOS-国内)', paymentChannel: 'wechat', currency: 'CNY', amount: 15000, packageBaseFee: 3000, packageDiscountRate: 1, paymentFee: 90, paymentRate: 0.006, isCommission: 1, commissionRate: 0.10, commissionAmount: 1191, settleAmount: 10719, payTime: 1739543400, refundTime: null },
  { orderId: 'ORD20260218002', outTradeNo: 'ALI20260218002', status: 1, packageName: '智能安防年卡', packageId: 'PKG_002', appInfo: 'SmartHome Pro (Android-国内)', paymentChannel: 'alipay', currency: 'CNY', amount: 59900, packageBaseFee: 12000, packageDiscountRate: 0.85, paymentFee: 359, paymentRate: 0.006, isCommission: 1, commissionRate: 0.10, commissionAmount: 4754, settleAmount: 42787, payTime: 1739802000, refundTime: null },
  { orderId: 'ORD20260220003', outTradeNo: 'AP20260220003', status: 1, packageName: 'Cloud Storage Monthly', packageId: 'PKG_001', appInfo: 'HomeStar (iOS-海外)', paymentChannel: 'applepay', currency: 'USD', amount: 2299, packageBaseFee: 460, packageDiscountRate: 1, paymentFee: 345, paymentRate: 0.015, isCommission: 1, commissionRate: 0.10, commissionAmount: 149, settleAmount: 1345, payTime: 1739750100, refundTime: null },
  { orderId: 'ORD20260225004', outTradeNo: 'WX20260225004', status: 2, packageName: '4G流量季卡', packageId: 'PKG_003', appInfo: 'ParkingCloud (iOS-国内)', paymentChannel: 'wechat', currency: 'CNY', amount: 29900, packageBaseFee: 6000, packageDiscountRate: 1, paymentFee: 179, paymentRate: 0.006, isCommission: 0, commissionRate: 0, commissionAmount: 0, settleAmount: 0, payTime: 1740182700, refundTime: 1740269100 },
  { orderId: 'ORD20260226005', outTradeNo: 'PP20260226005', status: 1, packageName: 'Smart Security Annual', packageId: 'PKG_002', appInfo: 'HomeStar (iOS-海外)', paymentChannel: 'paypal', currency: 'USD', amount: 8999, packageBaseFee: 1800, packageDiscountRate: 1, paymentFee: 351, paymentRate: 0.015, isCommission: 1, commissionRate: 0.10, commissionAmount: 685, settleAmount: 6163, payTime: 1740250200, refundTime: null },
];

// ── Enums ──
const platformTypeKV = { 1: 'iOS', 2: 'Android', 3: 'Web', 4: '小程序' };
const regionKV = { 1: '国内', 2: '海外', 3: '其他' };

const payDirLabel = { 1: '企业自收款', 2: '平台代收款' };
const payDirColor = { 1: 'orange', 2: 'red' };
const accountLabel = { 1: '消费账户', 2: '收益账户' };
const accountColor = { 1: 'blue', 2: 'green' };
const settleTypeLabel = { 1: '平台扣款', 2: '企业收入' };
const settleTypeColor = { 1: 'red', 2: 'green' };
const statusLabel = { 1: '待出账', 2: '待确认', 3: '已确认' };
const statusColor = { 1: '#999', 2: '#e6a23c', 3: '#67c23a' };

const orderStatusMap = {
  1: { label: '已支付', color: 'success' },
  2: { label: '已全额退款', color: 'error' },
  3: { label: '已部分退款', color: 'warning' },
  4: { label: '已作废', color: 'default' },
};

// ── Helpers ──
const fmtCent = (val) => {
  if (val == null) return '0.00';
  return (Number(val) / 100).toFixed(2);
};

const fmtRate = (val) => (val == null ? '—' : `${Number(val).toFixed(2)}%`);

const formatFeeSnapshot = (fees) => {
  const list = getConfiguredFeeList(fees || {});
  if (!list.length) return '未配置（按 0 计算）';
  return list.map((c) => `${c.label} ${formatFeeText(c.fee)}`).join('；');
};

// 操作记录 / 详情中使用的费率快照条目
const feeSnapshotItems = (record) => {
  const items = [
    <Descriptions.Item key="feeFlag" label="扣除支付手续费">{record.isDeductPaymentFee === 1 ? '是' : '否'}</Descriptions.Item>,
  ];
  if (record.isDeductPaymentFee === 1) {
    items.push(
      <Descriptions.Item key="feeAmount" label="支付手续费用">¥ {fmtCent(record.paymentFeeCny || 0)} / $ {fmtCent(record.paymentFeeUsd || 0)}</Descriptions.Item>,
      <Descriptions.Item key="feeRate" label="支付方式费率" span={2}>{formatFeeSnapshot(record.paymentFees)}</Descriptions.Item>,
    );
  }
  return items;
};

const renderDualAmount = (cny, usd, mainStyle = {}, subStyle = {}) => (
  <div>
    <div style={{ fontWeight: 600, ...mainStyle }}>¥ {fmtCent(cny)}</div>
    <div style={{ fontSize: 12, color: '#999', ...subStyle }}>$ {fmtCent(usd)}</div>
  </div>
);

const formatApps = (row, showPlatform = true) => {
  return (row.appInfoList || []).map(a => {
    if (!showPlatform || !a.systemPlatform) return a.appName;
    const platforms = a.systemPlatform.map(p =>
      `${platformTypeKV[p.platformType] || '未知'}-${regionKV[p.region] || '未知'}`
    );
    return `${a.appName} (${platforms.join('、')})`;
  });
};

const BillManage = () => {
  // ── State ──
  const [activeTab, setActiveTab] = useState('billed');
  const [billedData] = useState(mockBilled);
  const [unbilledData] = useState(mockUnbilled);

  // 出账日
  const [billDay, setBillDay] = useState(5);
  const [billDayEditVisible, setBillDayEditVisible] = useState(false);
  const [billDayEditVal, setBillDayEditVal] = useState(5);

  // 详情抽屉
  const [detailVisible, setDetailVisible] = useState(false);
  const [currentBillId, setCurrentBillId] = useState(null);

  // 确认出账
  const [confirmVisible, setConfirmVisible] = useState(false);
  const [confirmRow, setConfirmRow] = useState(null);
  const [confirmAction, setConfirmAction] = useState(1); // 1=确认出账, 2=重新出账
  const [confirmReason, setConfirmReason] = useState('');

  // 操作记录
  const [logsVisible, setLogsVisible] = useState(false);
  const [logsRow, setLogsRow] = useState(null);

  // ── 获取当前账单详情 ──
  const getCurrentDetail = () => {
    const all = [...billedData, ...unbilledData];
    return all.find(d => d.id === currentBillId) || null;
  };

  // ── Billed Columns ──
  const billedColumns = [
    {
      title: '账单编号', dataIndex: 'serialNumber', key: 'serialNumber', width: 170,
      render: (text) => (
        <span>
          <Text style={{ fontFamily: 'monospace', fontSize: 13 }}>{text}</Text>
          <Button
            type="link"
            size="small"
            icon={<CopyOutlined />}
            style={{ padding: 0, marginLeft: 4 }}
            onClick={() => { navigator.clipboard.writeText(text); message.success('已复制'); }}
          />
        </span>
      )
    },
    {
      title: '企业信息', key: 'enterprise', width: 200,
      render: (_, r) => (
        <div>
          <div style={{ fontWeight: 500, color: '#262626' }}>{r.companyName}</div>
          <Text type="secondary" style={{ fontSize: 12 }}>ID: {r.companyId}</Text>
        </div>
      )
    },
    {
      title: '出账App', key: 'apps', width: 210,
      render: (_, record) => {
        const apps = formatApps(record);
        if (apps.length === 0) return <Text type="secondary">—</Text>;
        if (apps.length <= 2) return <div>{apps.map((a, i) => <div key={i} style={{ fontSize: 12 }}>{a}</div>)}</div>;
        return (
          <Tooltip title={<div>{apps.map((a, i) => <div key={i}>{a}</div>)}</div>}>
            <div>
              {apps.slice(0, 2).map((a, i) => <div key={i} style={{ fontSize: 12 }}>{a}</div>)}
              <Text type="secondary" style={{ fontSize: 11 }}>等 {apps.length} 个端...</Text>
            </div>
          </Tooltip>
        );
      }
    },
    {
      title: '收款方向', dataIndex: 'paymentMethod', key: 'paymentMethod', width: 120,
      render: (val) => <Tag color={payDirColor[val]}>{payDirLabel[val] || '-'}</Tag>
    },
    {
      title: '抽佣扣手续费', key: 'deductFee', width: 110, align: 'center',
      render: (_, r) => (r.isDeductPaymentFee === 1
        ? <Tag color="green" style={{ border: 'none' }}>扣除</Tag>
        : <Tag style={{ border: 'none' }}>不扣</Tag>)
    },
    {
      title: '账单周期', dataIndex: 'date', key: 'date', width: 100,
      render: (text) => <Text>{text}</Text>
    },
    {
      title: '订单笔数', dataIndex: 'orderCount', key: 'orderCount', width: 100, align: 'right',
      render: (val) => <Text>{(val ?? 0)} 笔</Text>
    },
    {
      title: '订单总金额', key: 'orderTotal', width: 150, align: 'right',
      render: (_, r) => renderDualAmount(r.orderAmountCny, r.orderAmountUsd)
    },
    {
      title: '抽佣总额', key: 'commissionTotal', width: 140, align: 'right',
      render: (_, r) => renderDualAmount(r.commissionAmountCny, r.commissionAmountUsd, { color: '#e6a23c' }, { color: '#e6a23c' })
    },
    {
      title: '企业资金账户', key: 'settlementAccount', width: 120, align: 'center',
      render: (_, r) => <Tag color={accountColor[r.paymentMethod]}>{accountLabel[r.paymentMethod] || '-'}</Tag>
    },
    {
      title: '结算金额', key: 'settleAmount', width: 160, align: 'right',
      render: (_, r) => (
        <div>
          <Tag color={settleTypeColor[r.paymentMethod]} style={{ marginBottom: 4, fontSize: 11 }}>
            {settleTypeLabel[r.paymentMethod] || '-'}
          </Tag>
          {renderDualAmount(r.settleAmountCny, r.settleAmountUsd, { fontSize: 15, color: r.paymentMethod === 1 ? '#f50' : '#52c41a' })}
        </div>
      )
    },
    {
      title: '状态', dataIndex: 'status', key: 'status', width: 90,
      render: (s) => <span style={{ color: statusColor[s] }}>&#9679; {statusLabel[s] || '-'}</span>
    },
    {
      title: '操作', key: 'action', width: 160, fixed: 'right',
      render: (_, record) => (
        <Space size={0} split={<Divider type="vertical" style={{ margin: '0 4px' }} />}>
          {record.status === 2 && (
            <Button type="link" size="small" onClick={() => { setConfirmRow(record); setConfirmAction(1); setConfirmReason(''); setConfirmVisible(true); }}>立即确认</Button>
          )}
          {record.status === 3 && (
            <Button type="link" size="small" onClick={() => { setLogsRow(record); setLogsVisible(true); }}>操作记录</Button>
          )}
          <Button type="link" size="small" onClick={() => { setCurrentBillId(record.id); setDetailVisible(true); }}>详情</Button>
        </Space>
      )
    }
  ];

  // ── Unbilled Columns ──
  const unbilledColumns = [
    {
      title: '企业信息', key: 'enterprise', width: 220,
      render: (_, r) => (
        <div>
          <div style={{ fontWeight: 500, color: '#262626' }}>{r.companyName}</div>
          <Text type="secondary" style={{ fontSize: 12 }}>ID: {r.companyId}</Text>
        </div>
      )
    },
    {
      title: 'App范围', key: 'apps', width: 220,
      render: (_, record) => {
        const apps = formatApps(record, false);
        if (apps.length === 0) return <Text type="secondary">—</Text>;
        if (apps.length <= 2) return <div>{apps.map((a, i) => <div key={i} style={{ fontSize: 12 }}>{a}</div>)}</div>;
        return (
          <Tooltip title={<div>{apps.map((a, i) => <div key={i}>{a}</div>)}</div>}>
            <div>
              {apps.slice(0, 2).map((a, i) => <div key={i} style={{ fontSize: 12 }}>{a}</div>)}
              <Text type="secondary" style={{ fontSize: 11 }}>等 {apps.length} 个端...</Text>
            </div>
          </Tooltip>
        );
      }
    },
    {
      title: '收款方向', dataIndex: 'paymentMethod', key: 'paymentMethod', width: 120,
      render: (val) => <Tag color={payDirColor[val]}>{payDirLabel[val] || '-'}</Tag>
    },
    {
      title: '订单笔数', dataIndex: 'orderCount', key: 'orderCount', width: 100, align: 'right',
      render: (val) => <Text>{(val ?? 0)} 笔</Text>
    },
    {
      title: '订单总金额', key: 'orderTotal', width: 160, align: 'right',
      render: (_, r) => renderDualAmount(r.orderAmountCny, r.orderAmountUsd)
    },
    {
      title: '操作', key: 'action', width: 80, fixed: 'right',
      render: (_, record) => (
        <Button type="link" size="small" onClick={() => { setCurrentBillId(record.id); setDetailVisible(true); }}>详情</Button>
      )
    }
  ];

  // ── Detail Order Columns ──
  const getDetailOrderColumns = (detail) => {
    const cols = [
      {
        title: '订单编号', dataIndex: 'orderId', key: 'orderId', width: 190,
        render: (text) => (
          <span>
            <Text style={{ fontFamily: 'monospace', fontSize: 12 }}>{text}</Text>
            <Button
              type="link" size="small" icon={<CopyOutlined />}
              style={{ padding: 0, marginLeft: 4 }}
              onClick={() => { navigator.clipboard.writeText(text); message.success('已复制'); }}
            />
          </span>
        )
      },
      {
        title: '支付单号', dataIndex: 'outTradeNo', key: 'outTradeNo', width: 190,
        render: (text) => <Text style={{ fontFamily: 'monospace', fontSize: 12 }}>{text || '—'}</Text>
      },
      {
        title: '订单状态', dataIndex: 'status', key: 'status', width: 110,
        render: (s) => {
          const cfg = orderStatusMap[s];
          return cfg ? <Tag color={cfg.color}>{cfg.label}</Tag> : <Text type="secondary">—</Text>;
        }
      },
      {
        title: '套餐信息', key: 'package', width: 220,
        render: (_, r) => (
          <div>
            <div style={{ fontSize: 13 }}>{r.packageName || '—'}</div>
            <Text type="secondary" style={{ fontSize: 11 }}>{r.packageId || '—'}</Text>
          </div>
        )
      },
      {
        title: '应用信息', dataIndex: 'appInfo', key: 'appInfo', width: 160,
        render: (text) => <span>{text || '—'}</span>
      },
      {
        title: '支付通道', dataIndex: 'paymentChannel', key: 'paymentChannel', width: 110,
        render: (v) => PAYMENT_CHANNEL_LABEL[v] || v
      },
      {
        title: '币种', dataIndex: 'currency', key: 'currency', width: 80,
        render: (v) => <Tag color={v === 'CNY' ? 'orange' : 'blue'}>{v}</Tag>
      },
      {
        title: '订单金额', key: 'amount', width: 120, align: 'right',
        render: (_, r) => `${r.currency === 'CNY' ? '¥' : '$'} ${fmtCent(r.amount)}`
      },
      {
        title: '套餐底价', key: 'packageBaseFee', width: 140, align: 'right',
        render: (_, r) => {
          if (r.packageDiscountRate && r.packageDiscountRate !== 1) {
            return `${r.currency === 'CNY' ? '¥' : '$'} ${fmtCent(r.packageBaseFee)} * ${(r.packageDiscountRate * 100).toFixed(2)}%`;
          }
          return `${r.currency === 'CNY' ? '¥' : '$'} ${fmtCent(r.packageBaseFee)}`;
        }
      },
    ];
    if (detail && detail.isDeductPaymentFee === 1) {
      cols.push(
        {
          title: '支付手续费', key: 'paymentFee', width: 120, align: 'right',
          render: (_, r) => r.paymentFee == null ? <Text type="secondary">—</Text> : `${r.currency === 'CNY' ? '¥' : '$'} ${fmtCent(r.paymentFee)}`
        },
        {
          title: '支付费率', key: 'paymentRate', width: 100, align: 'right',
          render: (_, r) => r.paymentRate != null ? `${(r.paymentRate * 100).toFixed(2)}%` : '—'
        }
      );
    }
    cols.push(
      {
        title: '是否抽佣', dataIndex: 'isCommission', key: 'isCommission', width: 90,
        render: (v) => <Tag color={v === 1 ? 'success' : 'default'}>{v === 1 ? '是' : '否'}</Tag>
      },
      {
        title: '抽佣比例', key: 'commissionRate', width: 100,
        render: (_, r) => (
          r.isCommission === 1
            ? <Text style={{ color: '#409eff', fontWeight: 600 }}>{(r.commissionRate * 100).toFixed(2)}%</Text>
            : <Text type="secondary">—</Text>
        )
      },
      {
        title: '抽佣金额', key: 'commissionAmount', width: 120, align: 'right',
        render: (_, r) => (
          r.isCommission === 1
            ? `${r.currency === 'CNY' ? '¥' : '$'} ${fmtCent(r.commissionAmount)}`
            : <Text type="secondary">—</Text>
        )
      },
      {
        title: '企业结算金额', key: 'settleAmount', width: 140, align: 'right',
        render: (_, r) => `${r.currency === 'CNY' ? '¥' : '$'} ${fmtCent(r.settleAmount)}`
      },
      {
        title: '支付时间（UTC）', dataIndex: 'payTime', key: 'payTime', width: 180,
        render: (v) => {
          if (!v) return <Text type="secondary">—</Text>;
          const d = new Date(v * 1000);
          return d.toISOString().replace('T', ' ').substring(0, 19);
        }
      },
      {
        title: '退款时间（UTC）', dataIndex: 'refundTime', key: 'refundTime', width: 180,
        render: (v) => {
          if (!v) return <Text type="secondary">—</Text>;
          const d = new Date(v * 1000);
          return d.toISOString().replace('T', ' ').substring(0, 19);
        }
      }
    );
    return cols;
  };

  // ── Summary Cards for Detail Drawer ──
  const renderSummaryCards = (detail) => {
    if (!detail) return null;
    const cards = [
      { label: '订单笔数', value: `${detail.orderCount ?? 0} 笔`, bg: '#f5f7fa', color: '#303133' },
      {
        label: '订单总金额',
        value: <div><div>¥ {fmtCent(detail.orderAmountCny)}</div><div style={{ fontSize: 12, color: '#999' }}>$ {fmtCent(detail.orderAmountUsd)}</div></div>,
        bg: '#f5f7fa', color: '#303133'
      },
      {
        label: '底价总额',
        value: <div><div>¥ {fmtCent(detail.packageBaseFeeCny || 0)}</div><div style={{ fontSize: 12, color: '#999' }}>$ {fmtCent(detail.packageBaseFeeUsd || 0)}</div></div>,
        bg: '#f5f7fa', color: '#303133'
      },
    ];
    if (detail.isDeductPaymentFee === 1) {
      cards.push({
        label: '手续费总额',
        value: <div><div>¥ {fmtCent(detail.paymentFeeCny || 0)}</div><div style={{ fontSize: 12, color: '#999' }}>$ {fmtCent(detail.paymentFeeUsd || 0)}</div></div>,
        bg: '#f5f7fa', color: '#303133'
      });
    }
    cards.push(
      {
        label: '抽佣总额',
        value: <div><div>¥ {fmtCent(detail.commissionAmountCny)}</div><div style={{ fontSize: 12, color: '#999' }}>$ {fmtCent(detail.commissionAmountUsd)}</div></div>,
        bg: '#fdf6ec', color: '#e6a23c'
      },
      {
        label: detail.paymentMethod === 1 ? '平台扣款金额' : '企业结算金额',
        value: <div><div>¥ {fmtCent(detail.settleAmountCny)}</div><div style={{ fontSize: 12, color: '#999' }}>$ {fmtCent(detail.settleAmountUsd)}</div></div>,
        bg: '#fef0f0', color: detail.paymentMethod === 1 ? '#f56c6c' : '#67c23a'
      }
    );
    return (
      <div style={{ display: 'flex', gap: 16, marginBottom: 20, flexWrap: 'wrap' }}>
        {cards.map((c, i) => (
          <div key={i} style={{
            flex: '1 1 0', minWidth: 140, padding: '16px 12px', borderRadius: 6,
            background: c.bg, textAlign: 'center'
          }}>
            <div style={{ fontSize: 13, color: '#909399', marginBottom: 8 }}>{c.label}</div>
            <div style={{ fontSize: 18, fontWeight: 600, color: c.color }}>{c.value}</div>
          </div>
        ))}
      </div>
    );
  };

  // ── Log steps ──
  const renderSystemBillStep = (record) => (
    <Descriptions bordered column={2} size="small" style={{ background: '#fafafa', borderRadius: 6 }}>
      <Descriptions.Item label="账单编号">{record.serialNumber}</Descriptions.Item>
      <Descriptions.Item label="订单笔数">{record.orderCount} 笔</Descriptions.Item>
      <Descriptions.Item label="订单总金额">¥ {fmtCent(record.orderAmountCny)} / $ {fmtCent(record.orderAmountUsd)}</Descriptions.Item>
      <Descriptions.Item label="抽佣比例">{fmtRate(record.commissionRate)}</Descriptions.Item>
      <Descriptions.Item label="抽佣总额">¥ {fmtCent(record.commissionAmountCny)} / $ {fmtCent(record.commissionAmountUsd)}</Descriptions.Item>
      {feeSnapshotItems(record)}
      <Descriptions.Item label="结算金额" span={2}>¥ {fmtCent(record.settleAmountCny)} / $ {fmtCent(record.settleAmountUsd)}</Descriptions.Item>
    </Descriptions>
  );

  const renderRebillStep = (record) => (
    <div>
      <Alert message={record.rebillReason || '重新出账原因：抽佣比例与最新商务协议不符，需重新出账'} type="warning" showIcon style={{ marginBottom: 12, fontSize: 13 }} />
      <Descriptions bordered column={2} size="small" style={{ background: '#fafafa', borderRadius: 6 }}>
        <Descriptions.Item label="操作人">{record.operateUser || 'admin'}</Descriptions.Item>
        <Descriptions.Item label="新账单编号">{record.serialNumber}</Descriptions.Item>
        <Descriptions.Item label="系统重新出账时间">{record.rebillTime || record.billTime || '—'}</Descriptions.Item>
        <Descriptions.Item label="订单笔数">{record.orderCount} 笔</Descriptions.Item>
        <Descriptions.Item label="订单总金额">¥ {fmtCent(record.orderAmountCny)} / $ {fmtCent(record.orderAmountUsd)}</Descriptions.Item>
        <Descriptions.Item label="抽佣比例">{fmtRate(record.commissionRate)}</Descriptions.Item>
        <Descriptions.Item label="抽佣总额">¥ {fmtCent(record.commissionAmountCny)} / $ {fmtCent(record.commissionAmountUsd)}</Descriptions.Item>
        <Descriptions.Item label="结算金额" span={2}>¥ {fmtCent(record.settleAmountCny)} / $ {fmtCent(record.settleAmountUsd)}</Descriptions.Item>
      </Descriptions>
    </div>
  );

  const renderManualConfirmStep = (record) => (
    <Descriptions bordered column={2} size="small" style={{ background: '#fafafa', borderRadius: 6 }}>
      <Descriptions.Item label="账单编号">{record.serialNumber}</Descriptions.Item>
      <Descriptions.Item label="订单笔数">{record.orderCount} 笔</Descriptions.Item>
      <Descriptions.Item label="订单总金额">¥ {fmtCent(record.orderAmountCny)} / $ {fmtCent(record.orderAmountUsd)}</Descriptions.Item>
      <Descriptions.Item label="抽佣比例">{fmtRate(record.commissionRate)}</Descriptions.Item>
      <Descriptions.Item label="抽佣总额"><Text style={{ color: '#e6a23c', fontWeight: 600 }}>¥ {fmtCent(record.commissionAmountCny)} / $ {fmtCent(record.commissionAmountUsd)}</Text></Descriptions.Item>
      {feeSnapshotItems(record)}
      <Descriptions.Item label="结算金额"><Text style={{ color: '#e6a23c', fontWeight: 600 }}>¥ {fmtCent(record.settleAmountCny)} / $ {fmtCent(record.settleAmountUsd)}</Text></Descriptions.Item>
      <Descriptions.Item label="操作人" span={2}>{record.operateUser || 'admin'}</Descriptions.Item>
    </Descriptions>
  );

  const logSteps = (record) => [
    { color: '#409eff', title: '系统出账', time: record.billTime, render: () => renderSystemBillStep(record) },
    {
      color: '#f56c6c',
      title: '重新出账',
      time: '2026-03-07 09:15:00',
      render: () => renderRebillStep({ ...record, rebillTime: '2026-03-07 09:20:00', operateUser: 'admin', rebillReason: '抽佣比例与最新商务协议不符，需重新出账' })
    },
    { color: '#67c23a', title: '人工审核 - 确认出账', time: record.ackBillTime || record.billTime, render: () => renderManualConfirmStep({ ...record, operateUser: 'admin' }) },
  ];

  // ── Confirm Submit ──
  const handleConfirmSubmit = () => {
    if (confirmAction === 2 && !confirmReason.trim()) {
      message.warning('请输入重新出账原因');
      return;
    }
    message.success(confirmAction === 1 ? '确认出账成功' : '重新出账已发起');
    setConfirmVisible(false);
  };

  // ── Render ──
  const detail = getCurrentDetail();

  return (
    <div style={{ padding: 24 }}>
      {/* 抽佣出账日 */}
      <div style={{
        display: 'flex', alignItems: 'center', gap: 12,
        padding: '12px 20px', background: '#fff', borderRadius: 8,
        border: '1px solid #e4e7ed', marginBottom: 16
      }}>
        <Text strong style={{ fontSize: 14, color: '#303133', whiteSpace: 'nowrap' }}>抽佣出账日</Text>
        {billDay ? (
          <span style={{ fontSize: 14, color: '#606266' }}>
            每月 <strong style={{ fontSize: 22, fontWeight: 700, color: '#409eff', margin: '0 2px', verticalAlign: -2 }}>{billDay}</strong> 号
          </span>
        ) : (
          <span style={{ fontSize: 14, color: '#c0c4cc' }}>暂无配置</span>
        )}
        <Text type="secondary" style={{ fontSize: 12, color: '#b0b3bb', flex: 1 }}>系统在次月该日自动生成上月账单</Text>
        <Button type="link" onClick={() => { setBillDayEditVal(billDay); setBillDayEditVisible(true); }}>修改</Button>
      </div>

      {/* 出账日修改弹窗 */}
      <Modal
        title="修改抽佣出账日"
        open={billDayEditVisible}
        onOk={() => { setBillDay(billDayEditVal); message.success('出账日设置成功'); setBillDayEditVisible(false); }}
        onCancel={() => setBillDayEditVisible(false)}
        okText="保存"
        cancelText="取消"
        destroyOnClose
        width={420}
      >
        <div style={{
          fontSize: 13, color: '#909399', padding: '12px 16px',
          background: '#f7f8fa', borderRadius: 6, lineHeight: 1.6, marginBottom: 16
        }}>
          系统将在次月该日自动生成上月抽佣账单，修改后立即生效。
        </div>
        <Select
          value={billDayEditVal}
          onChange={setBillDayEditVal}
          style={{ width: '100%' }}
          size="large"
          options={Array.from({ length: 28 }, (_, i) => ({ label: `每月 ${i + 1} 号`, value: i + 1 }))}
        />
      </Modal>

      {/* 主卡片 */}
      <Card bordered={false} style={{ borderRadius: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.02)' }}>
        <Title level={4} style={{ marginBottom: 16 }}>抽佣账单审核</Title>
        <Tabs
          activeKey={activeTab}
          onChange={setActiveTab}
          items={[
            {
              key: 'billed',
              label: `系统已出账 (${billedData.length})`,
              children: (
                <>
                  <Form layout="inline" style={{ marginBottom: 16 }}>
                    <Form.Item><Input placeholder="账单编号" style={{ width: 170 }} /></Form.Item>
                    <Form.Item><Input placeholder="企业名称" style={{ width: 200 }} /></Form.Item>
                    <Form.Item>
                      <Select placeholder="收款方向" style={{ width: 130 }} allowClear>
                        <Select.Option value={1}>企业自收款</Select.Option>
                        <Select.Option value={2}>平台代收款</Select.Option>
                      </Select>
                    </Form.Item>
                    <Form.Item>
                      <Select placeholder="账单状态" style={{ width: 120 }} allowClear>
                        <Select.Option value={2}>待确认</Select.Option>
                        <Select.Option value={3}>已确认</Select.Option>
                      </Select>
                    </Form.Item>
                    <Form.Item><Input placeholder="账单周期（YYYY-MM）" style={{ width: 160 }} /></Form.Item>
                    <Form.Item>
                      <Space>
                        <Button type="primary" icon={<SearchOutlined />}>查询</Button>
                        <Button icon={<ReloadOutlined />}>重置</Button>
                      </Space>
                    </Form.Item>
                  </Form>
                  <Table
                    columns={billedColumns}
                    dataSource={billedData}
                    rowKey="id"
                    scroll={{ x: 2200 }}
                    pagination={{ showSizeChanger: true, showTotal: (total) => `共 ${total} 条记录` }}
                  />
                </>
              )
            },
            {
              key: 'unbilled',
              label: `系统未出账 (${unbilledData.length})`,
              children: (
                <>
                  <Form layout="inline" style={{ marginBottom: 16 }}>
                    <Form.Item><Input placeholder="企业名称" style={{ width: 200 }} /></Form.Item>
                    <Form.Item>
                      <Select placeholder="收款方向" style={{ width: 130 }} allowClear>
                        <Select.Option value={1}>企业自收款</Select.Option>
                        <Select.Option value={2}>平台代收款</Select.Option>
                      </Select>
                    </Form.Item>
                    <Form.Item>
                      <Space>
                        <Button type="primary" icon={<SearchOutlined />}>查询</Button>
                        <Button icon={<ReloadOutlined />}>重置</Button>
                      </Space>
                    </Form.Item>
                  </Form>
                  <Table
                    columns={unbilledColumns}
                    dataSource={unbilledData}
                    rowKey="id"
                    scroll={{ x: 900 }}
                    pagination={{ showSizeChanger: true, showTotal: (total) => `共 ${total} 条记录` }}
                  />
                </>
              )
            },
          ]}
        />
      </Card>

      {/* 账单详情抽屉 */}
      <Drawer
        title={<Space><FileTextOutlined style={{ color: '#1890ff' }} /><span>账单详情</span></Space>}
        width="75%"
        onClose={() => { setDetailVisible(false); setCurrentBillId(null); }}
        open={detailVisible}
        destroyOnClose
        extra={detail && detail.status === 2 && (
          <Button type="primary" onClick={() => { setConfirmRow(detail); setConfirmAction(1); setConfirmReason(''); setConfirmVisible(true); }}>立即确认</Button>
        )}
      >
        {detail ? (
          <>
            <Descriptions bordered column={3} size="small" style={{ marginBottom: 20 }}>
              <Descriptions.Item label="账单编号">{detail.serialNumber}</Descriptions.Item>
              <Descriptions.Item label="账单周期">{detail.date}</Descriptions.Item>
              <Descriptions.Item label="状态">
                <span style={{ color: statusColor[detail.status] }}>&#9679; {statusLabel[detail.status] || '-'}</span>
              </Descriptions.Item>
              <Descriptions.Item label="企业名称">{detail.companyName}</Descriptions.Item>
              <Descriptions.Item label="出账App" span={2}>
                {formatApps(detail).length > 0 ? (
                  <Tooltip title={<div>{formatApps(detail).map((a, i) => <div key={i}>{a}</div>)}</div>}>
                    <span>
                      {formatApps(detail).slice(0, 2).join('  ')}
                      {formatApps(detail).length > 2 && <Text type="secondary"> ... 等 {formatApps(detail).length} 个端</Text>}
                    </span>
                  </Tooltip>
                ) : <Text type="secondary">—</Text>}
              </Descriptions.Item>
              <Descriptions.Item label="收款方向">
                <Tag color={payDirColor[detail.paymentMethod]}>{payDirLabel[detail.paymentMethod] || '-'}</Tag>
              </Descriptions.Item>
              <Descriptions.Item label="扣除套餐底价">
                <div>
                  {detail.isDeductBasePrice === 1
                    ? <span style={{ color: '#67c23a' }}>&#9679; 是</span>
                    : <span style={{ color: '#999' }}>&#9679; 否</span>}
                  <div style={{ fontSize: 11, color: '#8c8c8c', marginTop: 2 }}>
                    {detail.paymentMethod === 1 ? '订单产生时已在企业消费账户中扣除' : '参与本账期抽佣计算'}
                  </div>
                </div>
              </Descriptions.Item>
              <Descriptions.Item label="扣除支付手续费">
                <div>
                  {detail.isDeductPaymentFee === 1
                    ? <span style={{ color: '#67c23a' }}>&#9679; 是</span>
                    : <span style={{ color: '#999' }}>&#9679; 否</span>}
                  <div style={{ fontSize: 11, color: '#8c8c8c', marginTop: 2 }}>
                    {detail.isDeductPaymentFee === 1
                      ? (detail.paymentMethod === 1 ? '参与本账期抽佣基数计算，不单独扣款' : '出账时从订单金额中扣除')
                      : '手续费不参与抽佣基数计算'}
                  </div>
                </div>
              </Descriptions.Item>
              <Descriptions.Item label="结算账户">
                <Tag color={accountColor[detail.paymentMethod]}>{accountLabel[detail.paymentMethod] || '-'}</Tag>
              </Descriptions.Item>
              {detail.status === 3 && (
                <Descriptions.Item label="确认出账时间">{detail.ackBillTime || '—'}</Descriptions.Item>
              )}
              <Descriptions.Item label="系统出账时间">{detail.billTime || '—'}</Descriptions.Item>
            </Descriptions>

            {/* 金额汇总卡片 */}
            {renderSummaryCards(detail)}

            {/* 订单明细 */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
              <Title level={5} style={{ margin: 0, fontWeight: 600 }}>
                <InfoCircleOutlined style={{ color: '#1890ff', marginRight: 4 }} />订单明细
              </Title>
              <Space>
                <Input placeholder="订单号" style={{ width: 220 }} size="small" />
                <Button size="small">查询</Button>
                <Button size="small" icon={<DownloadOutlined />}>导出</Button>
              </Space>
            </div>
            <Table
              columns={getDetailOrderColumns(detail)}
              dataSource={mockDetailOrders}
              rowKey="orderId"
              size="small"
              scroll={{ x: 'max-content' }}
              pagination={{ showSizeChanger: true, showTotal: (total) => `共 ${total} 条记录` }}
            />
          </>
        ) : (
          <Empty description="暂无数据" />
        )}
      </Drawer>

      {/* 确认出账弹窗 */}
      <Modal
        title="确认出账"
        open={confirmVisible}
        onOk={handleConfirmSubmit}
        onCancel={() => setConfirmVisible(false)}
        okText={confirmAction === 2 ? '确认重出' : '确认出账'}
        cancelText="取消"
        destroyOnClose
        width={560}
      >
        {confirmRow && (
          <div style={{ padding: '8px 0' }}>
            <Alert
              message={confirmRow.paymentMethod === 2 ? '本期结算为《企业收益账户》余额增加！' : '本期结算为《企业消费账户》余额支出！'}
              type="success"
              showIcon
              style={{ marginBottom: 16 }}
            />
            <Descriptions bordered column={2} size="small" style={{ marginBottom: 16 }}>
              <Descriptions.Item label="账单编号" span={2}>{confirmRow.serialNumber}</Descriptions.Item>
              <Descriptions.Item label="企业">{confirmRow.companyName}</Descriptions.Item>
              <Descriptions.Item label="账单周期">{confirmRow.date}</Descriptions.Item>
              <Descriptions.Item label="订单笔数">{confirmRow.orderCount ?? 0} 笔</Descriptions.Item>
            </Descriptions>
            <div style={{ marginBottom: 16 }}>
              <div style={{ marginBottom: 8, fontWeight: 500 }}>确认操作</div>
              <Select value={confirmAction} onChange={setConfirmAction} style={{ width: '100%' }}>
                <Select.Option value={1}>
                  <Space><CheckCircleOutlined style={{ color: '#52c41a' }} />确认出账</Space>
                </Select.Option>
                <Select.Option value={2}>
                  <Space><ReloadOutlined style={{ color: '#e6a23c' }} />重新出账</Space>
                </Select.Option>
              </Select>
            </div>
            {confirmAction === 2 && (
              <>
                <div style={{ marginBottom: 8, fontWeight: 500 }}>重新出账原因</div>
                <Input.TextArea
                  value={confirmReason}
                  onChange={(e) => setConfirmReason(e.target.value)}
                  rows={4}
                  maxLength={200}
                  showCount
                  placeholder="请输入重新出账原因"
                />
              </>
            )}
          </div>
        )}
      </Modal>

      {/* 操作记录弹窗 */}
      <Modal
        title="操作记录"
        open={logsVisible}
        onCancel={() => setLogsVisible(false)}
        footer={null}
        width={800}
        destroyOnClose
      >
        {logsRow ? (
          <div style={{ padding: '8px 0' }}>
            <Alert
              message={logsRow.paymentMethod === 2 ? '本期结算为《企业收益账户》余额增加！' : '本期结算为《企业消费账户》余额支出！'}
              type="success"
              showIcon
              style={{ marginBottom: 20 }}
            />
            {logSteps(logsRow).map((step, idx) => (
              <div key={idx} style={{
                position: 'relative', paddingLeft: 20, marginBottom: idx < logSteps.length - 1 ? 24 : 0
              }}>
                {idx < logSteps.length - 1 && (
                  <div style={{
                    position: 'absolute', left: 5, top: 14, bottom: -24,
                    width: 1, background: '#dcdfe6'
                  }} />
                )}
                <span style={{
                  display: 'inline-block', width: 10, height: 10, borderRadius: '50%',
                  background: step.color, verticalAlign: 'middle',
                  position: 'relative', left: -20, marginRight: -12
                }} />
                <div style={{ marginBottom: 12, lineHeight: '20px' }}>
                  <span style={{ fontWeight: 600, color: step.color }}>{step.title}</span>
                  <Text type="secondary" style={{ fontSize: 12, marginLeft: 12 }}>{step.time}</Text>
                </div>
                <div style={{ paddingLeft: 4 }}>
                  {step.render()}
                </div>
              </div>
            ))}
          </div>
        ) : (
          <Empty description="暂无操作记录" />
        )}
      </Modal>
    </div>
  );
};

export default BillManage;
